import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { setLocale } from '../../actions';

const LanguageGridButton = (props) => {
    const {language, toggleModal, activeLanguage} = props;

    const dispatch = useDispatch();

    function handleLanguageLabel(item) {
      switch (item) 
        {
            case "auto":
              return <FormattedMessage id='lang.auto_label' defaultMessage='Auto Detect' />;
            case "en_EN":
              return <FormattedMessage id='lang.english_label' defaultMessage='English' />;
            case "es_ES":
              return <FormattedMessage id='lang.spanish_label' defaultMessage='Español' />;
            case "fr_FR":
                return <FormattedMessage id='lang.french_label' defaultMessage='Français' />;
            case "pt_BR":
                return <FormattedMessage id='lang.portuguese_label' defaultMessage='Português' />;
            case "ru_RU":
              return <FormattedMessage id='lang.russian_label' defaultMessage='Русский' />;
            case "zh_TW":
              return <FormattedMessage id='lang.chinese_label' defaultMessage='中文' />;
            default:
                break;
        }
    }

    function handleLocaleChange(code) {
      dispatch( setLocale(code));
    }

    return (
      <div className={`${language === activeLanguage ? 'border-[#1A658F]' : 'border-gray-900'} bg-white relative flex items-center space-x-8 border px-5 py-3 shadow-sm text-center hover:border-[#1A658F] focus-within:ring-2 focus-within:ring-blue-500 focus-within:ring-offset-2 my-2 rounded-sm`}>
      <div className="min-w-0 flex-1 flex items-center py-2">
      <input
      type="radio"
      name="language"
      checked={language === activeLanguage}
      onChange={() => handleLocaleChange(language)}
      className="form-radio text-[#1A658F] focus:ring-[#1A658F] focus:outline-none rounded-full"
      />
      <button
      className="focus:outline-none hover:text-[#1A658F] ml-3 rounded-sm"
      onClick={() => { toggleModal(); handleLocaleChange(language); }}
      >
      <span className="absolute inset-0" aria-hidden="true" />
      <p className={`${language === activeLanguage ? 'text-[#1A658F]' : ''} text-sm text-center font-medium`}>{handleLanguageLabel(language)}</p>
      </button>
      </div>
      </div>
    );
};

export default LanguageGridButton;